"use strict";Object.defineProperty(exports, "__esModule", {value: true});// A platform-neutral key chord. `mod` is Cmd on a Mac and Ctrl elsewhere; a
// chord with no modifier never matches a key event.














// Opens the + menu.
 const MENU_SHORTCUT = { key: '/', mod: true }; exports.MENU_SHORTCUT = MENU_SHORTCUT

// The aria-keyshortcuts spelling. The web app shows no shortcut labels, so
// this is the only place a shortcut is spelled out.
 const shortcutAriaKeys = (shortcut, mac) => [
  shortcut.mod && (mac ? 'Meta' : 'Control'),
  shortcut.shift && 'Shift',
  shortcut.key.length === 1 ? shortcut.key.toUpperCase() : shortcut.key,
].filter(Boolean).join('+'); exports.shortcutAriaKeys = shortcutAriaKeys

 const matchesShortcut = (event, shortcut, mac) => {
  if (!shortcut.mod) return false
  const mod = mac ? event.metaKey : event.ctrlKey
  const other = mac ? event.ctrlKey : event.metaKey
  return mod && !other && !event.altKey
    && event.shiftKey === !!shortcut.shift
    && event.key.toLowerCase() === shortcut.key.toLowerCase()
}; exports.matchesShortcut = matchesShortcut
